import {useState} from "react";

interface FilterAlphabeticalProps {
	options: string[];
	onChange: (selectedOption: string[]) => void;
}

export default function FilterAlphabetical(props: FilterAlphabeticalProps) {
	const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

	const handleOptionChange = (option: string) => {
		let newSelectedOptions: string[] = [];

		if (selectedOptions.includes(option)) {
			newSelectedOptions = selectedOptions.filter((selectedOption) => selectedOption !== option);
			setSelectedOptions(newSelectedOptions);
		} else {
			newSelectedOptions = [option];
			setSelectedOptions(newSelectedOptions);
		}

		props.onChange(newSelectedOptions);
	}

	return (
		<div
			className={'axial-alphabetical-filter tw-w-full tw-max-w-[calc(100dvw_-_40px)] scrollbar tw-overflow-x-auto tw-pb-3'}>
			<div className={'tw-flex tw-border tw-border-[#DCDCDC] tw-w-full'}>
				{props.options.map((option) => (
					<a data-current={selectedOptions[0] === option ? 'true' : 'false'} className={'hover:tw-underline hover:tw-cursor-pointer tw-text-2xl tw-uppercase tw-h-[48px] tw-min-w-[48px] tw-flex tw-flex-1 tw-justify-center tw-items-center tw-border-r last:tw-border-none tw-border-[#DCDCDC] tw-bg-white'}
					   onClick={() => handleOptionChange(option)}>
						{option}
					</a>
				))}
			</div>
		</div>
	)
}